import { isFailureAction, isRequestAction, isSuccessAction } from '@/utils/actions.utils'
import { errorActions } from '@/redux/actions'

const excludedActions = /\w*(_FAILURE|_REQUEST|_SUCCESS)/


const retryDispatch = (store) => (next) => async (action) => {

	const { dispatch, getState } = store
	const pendingActions = getState().error?.actionsToRetry?.pendingActions

	if (action.type === 'RETRY_ACTION_RETRY') {
		for (const pendingAction of pendingActions) {
			dispatch(errorActions.actionAllowRetry(pendingAction))
		}
		dispatch(errorActions.resetActions())
		return next(action)
	}

	if (typeof action !== 'object' || !String(action.type).match(excludedActions)) {
		return next(action)
	}

	if (isRequestAction(action.type)) {
		return next(action)
	}

	if (isFailureAction(action.type)) {
		if (action.allowRetry) {
			if (action?.error?.code === 'ETIMEDOUT') {
				dispatch(errorActions.showRetryCta())
			} else {
				dispatch(errorActions.resetActions())
				dispatch(errorActions.setError(action?.error))
			}
		}
		return next(action)
	}

	if (isSuccessAction(action.type)) {
		if (action.allowRetry) {
			dispatch(errorActions.resetActions())
		}
		return next(action)
	}

}

export default retryDispatch